import React from 'react';
import { styled, Dialog, Typography, withStyles } from '@material-ui/core';
import { OutlinedButton } from '@ds/react-components';
import { ReactComponent as AlertIcon } from 'assets/icons/ic-alert.svg';

export const ConfirmDialog = withStyles({
  paperScrollPaper: {
    maxWidth: '300px',
  },
  root: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
})(Dialog);

export const DialogContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '28px',
});

export const DangerIcon = styled(AlertIcon)({
  width: '46px',
  height: '46px',
  color: '#CF3341',
});

export const Title = styled((props) => (
  <Typography variant={'h4'} {...props} />
))(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.common.black,
  marginTop: '12px',
  display: 'inline-block',
}));

export const ContentTextContainer = styled('div')({
  textAlign: 'center',
  marginTop: '8px',
  display: 'inline-block',
  width: '100%',
});

export const ContentText = styled((props) => (
  <Typography variant={'body1'} {...props} />
))(({ theme }) => ({
  fontWeight: 'normal',
  color: theme.palette.common.lightText,
  padding: 0,
}));

export const ActionButtonContainer = styled('div')({
  display: 'flex',
  marginTop: '18px',
});

export const NoButton = styled(OutlinedButton)({
  marginLeft: '16px',
});
